import { cva } from 'class-variance-authority'

export const button = cva(
  [
    'border rounded-lg',
    'active:bg-opacity-80',
    'disabled:opacity-80 disabled:cursor-not-allowed',
    'flex items-center gap-2',
    'transition-all duration-100',
    'font-normal leading-6',
  ],
  {
    variants: {
      intent: {
        mm: 'bg-[#9370db]  text-[#242424]  hover:bg-violet-200 disabled:opacity-50 disabled:hover:bg-violet-300',
        wildberries:
          'bg-[#3A0078]  text-white border-transparent,  hover:bg-[#612C99] disabled:opacity-50 disabled:hover:bg-[#2B005A] ',
        ozon: 'bg-blue-600 text-white border-transparent hover:bg-blue-500 disabled:opacity-50 disabled:hover:bg-blue-600',
        cdek: ' bg-green-600 text-white border border-transparent hover:bg-green-500 disabled:hover:bg-green-600',
        saferoute:
          'bg-[#242424] text-white  hover:bg-gray-600 disabled:opacity-50 disabled:hover:bg-gray-300',
        epackage:
          'bg-gray-600 text-white  hover:bg-gray-400 disabled:opacity-50 disabled:hover:bg-gray-300',
        russianpostru:
          'bg-white text-[#242424]  hover:bg-gray-200 disabled:opacity-50 disabled:hover:bg-gray-200',
        ems: 'bg-gray-400 text-white border-transparent hover:bg-gray-500 disabled:opacity-50 disabled:hover:bg-gray-600',
        pickup:
          'bg-blue-400 text-white border-transparent hover:bg-blue-500 disabled:opacity-50 disabled:hover:bg-blue-600',
        dhl: 'bg-[#FFCC00] text-[#242424]  border-transparent  hover:bg-[#F6DB71] disabled:opacity-50 disabled:hover:bg-yellow-400',
        yellow:
          'bg-yellow-300 text-white border-transparent hover:bg-yellow-200 disabled:opacity-50 disabled:hover:bg-yellow-400',
        orange:
          'bg-[#ff9b19]  text-white border-transparent hover:bg-orange-300 disabled:opacity-50 disabled:hover:bg-orange-400',
        primary:
          'bg-blue-600 text-white border-transparent hover:bg-blue-500 disabled:opacity-50 disabled:hover:bg-blue-600',
        secondary:
          'bg-white text-gray-800 border-gray-300 hover:bg-gray-200 disabled:hover:bg-white  rounded-lg',
        ghost:
          'bg-white text-[#242424] border-transparent disabled:hover:bg-white',
        gray: 'bg-[#E6E6E6] text-[#242424] border-transparent hover:bg-slate-300 disabled:hover:bg-slate-200 ',
        danger:
          'bg-red-600 text-white border-transparent hover:bg-red-500 disabled:hover:bg-red-500',
        dark: 'bg-gray-800 text-white border-transparent hover:bg-gray-900 disabled:hover:bg-gray-800',
        success:
          'bg-green-600 text-white border border-transparent hover:bg-green-500 disabled:hover:bg-green-600',
      },
      size: {
        small: ['text-sm', 'py-1', 'px-2'],
        medium: ['text-base', 'py-2', 'px-4'],
        big: ['text-lg', 'py-3', 'px-6'],
        huge: ['text-lg', 'py-2', 'px-4'],
        new: ['text-sm', 'h-10', 'px-4'],
      },
    },
    compoundVariants: [
      {
        intent: 'primary',
        size: 'medium',
      },
      { intent: 'gray', size: 'huge' },
    ],
    defaultVariants: {
      intent: 'primary',
      size: 'medium',
    },
  },
)
